<script>
import ReportingApi from "@/services/reporting-api";

export default {
    props: {
        data: {
            type: Array,
            default: () => [],
        },
        data1: {
            type: Array,
            default: () => [],
        },
        categories: {
            type: Array,
            default: () => [],
        },
        title: {
            type: String,
            default: () => '',
        },
        name: {
            type: String,
            default: () => '',
        },
        name1: {
            type: String,
            default: () => '',
        },
        campaignId: {
            type: Number,
            default: null,
        },
    },

    data() {
        return {
            barChart: {},
            pageChart:1,
            pageSize:10,
            apexChartsBarKey:0
        };
    },

    mounted() {
        this.renderBarChart();
    },

    
    watch:{
        pageSize:function(){
        this.getDataByPageSize()
        }
    },

    
    methods: {
        getDataByPageSize(){

            ReportingApi.getScanPerDay(this.pageChart, this.campaignId, this.pageSize).then(result => {
                if(result){
                    this.barChart = {
                        series: [
                            {
                                name: this.name,
                                data: result.entryCount
                            },
                            {
                                name: this.name1,
                                data: result.uniqueScans
                            }
                        ],
                        chartOptions: {
                    chart: {
                        toolbar: {
                            show: true,
                        },
                        height: '350'
                    },
                    plotOptions: {
                        bar: {
                            horizontal: false,
                        }
                    },
                    stroke: {
                        show: true,
                        width: 2,
                        colors: ['transparent']
                    },
                    dataLabels: {
                        enabled: false,
                        formatter: function (val) {
                            return val === 0 ? '' : val; 
                        },
                        style: {
                            fontSize: '11px',
                        },
                    },
                    colors: ['#50a5f1', '#ff4560'],
                    grid: {
                        borderColor: '#ffffff',
                    },
                    xaxis: {
                        categories: result.date,
                        labels: {
                            style: {
                                colors: ['#121212'],
                                fontSize: '12px'
                            }
                        }
                    },
                    tooltip: {
                        enabled: true,
                    },

                    responsive: [{
                        breakpoint: 768, 
                        options: {
                            chart: {
                            toolbar: {
                                show: false
                            }
                            }
                        }
                        }]
                }
                    },
                    this.apexChartsBarKey ++;
                }else if((result == null || result.length == 0) && (this.pageChart -1) ==1){
                this.barChart = {}
                }
            })
        },

        nextPage(){

            ReportingApi.getScanPerDay(this.pageChart + 1, this.campaignId, this.pageSize).then(result => {
                if(result){
                    this.pageChart ++;
                    this.barChart = {
                        series: [
                            {
                                name: this.name,
                                data: result.entryCount
                            },
                            {
                                name: this.name1,
                                data: result.uniqueScans
                            }
                        ],
                        chartOptions: {
                    chart: {
                        toolbar: {
                            show: true,
                        },
                        height: '350'
                    },
                    plotOptions: {
                        bar: {
                            horizontal: false,
                        }
                    },
                    stroke: {
                        show: true,
                        width: 2,
                        colors: ['transparent']
                    },
                    dataLabels: {
                        enabled: false,
                        formatter: function (val) {
                            return val === 0 ? '' : val; 
                        },
                        style: {
                            fontSize: '11px',
                        },
                    },
                    colors: ['#50a5f1', '#ff4560'],
                    grid: {
                        borderColor: '#ffffff',
                    },
                    xaxis: {
                        categories: result.date,
                        labels: {
                            style: {
                                colors: ['#121212'],
                                fontSize: '12px'
                            }
                        }
                    },
                    tooltip: {
                        enabled: true,
                    },

                    responsive: [{
                        breakpoint: 768, 
                        options: {
                            chart: {
                            toolbar: {
                                show: false
                            }
                            }
                        }
                        }]
                }
                    },
                    this.apexChartsBarKey ++;
                }else if((result == null || result.length == 0) && (this.pageChart -1) ==1){
                this.barChart = {}
                }
            })
        },

        previousPage(){
            ReportingApi.getScanPerDay(this.pageChart - 1 , this.campaignId, this.pageSize).then(result => {
                if(result){
                    this.pageChart -- ;
                    this.barChart = {
                        series: [
                            {
                                name: this.name,
                                data: result.entryCount
                            },
                            {
                                name: this.name1,
                                data: result.uniqueScans
                            }
                        ],
                        chartOptions: {
                    chart: {
                        toolbar: {
                            show: true,
                        },
                        height: '350'
                    },
                    plotOptions: {
                        bar: {
                            horizontal: false,
                        }
                    },
                    stroke: {
                        show: true,
                        width: 2,
                        colors: ['transparent']
                    },
                    dataLabels: {
                        enabled: false,
                        formatter: function (val) {
                            return val === 0 ? '' : val; 
                        },
                        style: {
                            fontSize: '11px',
                        },
                    },
                    colors: ['#50a5f1', '#ff4560'],
                    grid: {
                        borderColor: '#ffffff',
                    },
                    xaxis: {
                        categories: result.date,
                        labels: {
                            style: {
                                colors: ['#121212'],
                                fontSize: '12px'
                            }
                        }
                    },
                    tooltip: {
                        enabled: true,
                    },
                    responsive: [{
                        breakpoint: 768, 
                        options: {
                            chart: {
                            toolbar: {
                                show: false
                            }
                            }
                        }
                        }]
                }
                    },
                    this.apexChartsBarKey ++;

                }
                else if((result == null || result.length == 0) && (this.pageChart -1) ==1){
                    this.barChart = {}
                    }
            })
        },

        renderBarChart() {
            this.barChart = {
                series: [
                    {
                        name: this.name,
                        data: this.data
                    },
                    {
                        name: this.name1,
                        data: this.data1
                    }
                ],
                chartOptions: {
                    chart: {
                        toolbar: {
                            show: true,
                        },
                        height: '350'
                    },
                    plotOptions: {
                        bar: {
                            horizontal: false,
                        }
                    },
                    stroke: {
                        show: true,
                        width: 2,
                        colors: ['transparent']
                    },
                    dataLabels: {
                        enabled: false,
                        formatter: function (val) {
                            return val === 0 ? '' : val; 
                        },
                        style: {
                            fontSize: '11px',
                        },
                    },
                    colors: ['#50a5f1', '#ff4560'],
                    grid: {
                        borderColor: '#ffffff',
                    },
                    xaxis: {
                        categories: this.categories,
                        labels: {
                            style: {
                                colors: ['#121212'],
                                fontSize: '12px'
                            }
                        }
                    },
                    tooltip: {
                        enabled: true,
                    },
                    responsive: [{
                        breakpoint: 768, 
                        options: {
                            chart: {
                            toolbar: {
                                show: false
                            }
                            }
                        }
                        }]
                }
            };
        }
    }
};
</script>

<template>
    <div class="card h-100 "   style="border:1px solid #ddd;">
        <div class="card-body ">

            <div class="row">
                <div class="col-md-6 col-12">
                    <h4 class="text-dark text-uppercase font-weight-bold">{{ title }}</h4>
                </div>


                 <div class="col-md-6 col-12 d-flex justify-content-end">
                  <div>
                    <img alt="left" class="mr-2" width="17px" src="@/assets/icons/left-2.svg" style="cursor: pointer;" @click="nextPage()" />
                    <span class="text-center mr-2">page {{pageChart}}</span>              
                    <img alt="right" width="17px" src="@/assets/icons/right-2.svg" style="cursor: pointer; " @click="previousPage()"  :style="{ opacity: pageChart === 1 ? 0.5 : 1, pointerEvents: pageChart === 1 ? 'none' : 'auto' }"                    />
                  </div>
                  <div>
                    <select class="custom-select custom-select-sm ml-2"  v-model="pageSize">
                      <option selected value="10">10</option>
                      <option value="30">30</option>
                    </select>
                  </div>
                </div>
            </div>

            <apexchart
             v-if="barChart.series && barChart.series.length && barChart.chartOptions" 
                :key="apexChartsBarKey"
                class="apex-charts"
                height="350"
                type="bar"
                :series="barChart.series"
                :options="barChart.chartOptions"
            ></apexchart>
            <div v-else class="d-flex justify-content-center align-items-center text-secondary h-100" style="min-height:340px;" >Pas de collecte de données</div>

        </div>
    </div>
</template>

<style>
.apex-charts text {
    font-weight: bold !important;
    fill: #121212 !important;
}

.apexcharts-yaxis text, .apexcharts-xaxis text {
    font-weight: bold !important;
    letter-spacing: 0px !important;
    fill: #121212 !important;
}

.apexcharts-tooltip.apexcharts-theme-light.apexcharts-active {
    z-index: 999999;
}
</style>
